// @flow
import React from 'react'

import styles from './media.module.scss'

const Placeholder = () => (
  <div className={`d-flex mb-5 ${styles.media}`}>
    <div className={`${styles.coverartContainer} flex0`}>
      <div className="ps-relative">
        <figure className={`${styles.coverartFigure} ${styles.placeholder}`} />
      </div>
    </div>
    <div className={`${styles.detailContainer} flex1`}>
      <div className={`${styles.placeholderText} mb-2`} />
      <div
        className={`${styles.placeholderText} ${styles.sm} ${styles.half} mb-3`}
      />
      <div className={`${styles.placeholderText} mb-2`} />
      <div className={`${styles.placeholderText} mb-2`} />
      <div className={`${styles.placeholderText} ${styles.half} mb-2`} />
    </div>
  </div>
)

export default Placeholder
